import Navbar from './sections/Navbar';
import Hero from './sections/Hero';
import Features from './sections/Features';
import FAQ from './sections/FAQ';
import CTA from './sections/CTA';
import Footer from './sections/Footer';
import { LanguageProvider } from './contexts/LanguageContext';

import { Toaster } from 'sonner';

function App() {
  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[var(--bg-primary)] text-[var(--ds-text-primary)] relative">
        <div className="fixed inset-0 bg-tech-pattern pointer-events-none z-0" />
        <Navbar />
        <main>
          <Hero />
          <Features />
          <FAQ />
          <CTA />
        </main>
        <Footer />
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
